import React from "react";
import classNames from "classnames/bind";
import styles from "../SideMenu/SideMenu.module.scss";
import { Link } from "react-router-dom";
import { usePath } from "routes/LayoutContext";

var cx = classNames.bind(styles);

const AppFooter = (props: { className?: string; align?: string }) => {
  const path = usePath();
  const { className, align, ...restProps } = props;
  return (
    <footer className={cx("navFooterBottom", className)} {...restProps}>
      {/* <div className={cx("socialBlock", align)}>
        <a
          href="https://web.telegram.org/#/im?p=@uniglobal"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={require("./imgs/ico_telegram.png")} alt="" />
        </a>
        <a
          href="https://www.facebook.com/gcfxapp/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={require("./imgs/ico_fb.png")} alt="" />
        </a>
        <a
          href="https://www.twitter.com/gcfxapp/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={require("./imgs/ico_twitter.png")} alt="" />
        </a>
        <a
          href="https://www.instagram.com/gcfxapp/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={require("./imgs/ico_ig.png")} alt="" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCtlMlFebqACYTlcLS3CRpoA"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={require("./imgs/ico_youtube.png")} alt="" />
        </a>
      </div> 
      <div className={cx("legalBlock", align)}>
        <Link to={`${path}/disclaimer`}>Disclaimer</Link>&nbsp;&nbsp;
        <Link to={`${path}/privacy`}>Privacy Policy</Link>
      </div>
      <div className={cx("copyright", align)}>
        © UNI GLOBAL SYSTEM PTE. LTD.
      </div>
      */}
    </footer>
  );
};

export default AppFooter;
